import { MapsPortal as App } from "maps-portal";
import { NextPage } from "next";
import { NextSeo } from "next-seo";
import { AccountGuard } from "auth";

const DataPage: NextPage = () => {
	return (
		<>
			<NextSeo title="Mango GIS - Maps" />
			<AccountGuard>
				<App />
			</AccountGuard>
		</>
	);
};

export default DataPage;
